import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import SectionLoadingcontainer from './sectionloadingcontainer';
import { updateAppState,updateComponentState } from '../actions/actions';

class WorkInProgress extends Component {
	constructor(props) {
		super(props);
		this.state = {
			workinprogress : [],
			totalwipcalls : 0,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	onload(){
		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			axios.get(`/api/workinprogress?pagetype=widget`).then((response) => {
				if (response.data.message == 'success') {
					let workinprogress=[],totalwipcalls=0 , totalless_7=0,totalmore_7=0;
					if(response.data.main && response.data.main.length > 0){
						let ccs_count = {};
						response.data.main.forEach((item)=>{
							totalless_7 += item.less_7;
							totalmore_7 += item.more_7;
							ccs_count[item.zzzcontractcoveragestatus] = item.less_7 + item.more_7;
						});

						if(this.props.app.companyid == 8) totalwipcalls = ccs_count['Service Provider'] || 0;
						else totalwipcalls = totalless_7 + totalmore_7;

						workinprogress = response.data.main; 
					}
					workinprogress.push({
						zzzcontractcoveragestatus: 'Total Calls',
						less_7: totalless_7,
						more_7: totalmore_7
					});
					this.setState({
						workinprogress,
						totalwipcalls,
						loaderflag : false
					});
					this.props.updateComponentState(this.props.form,{
						workinprogress,
						totalwipcalls,
						loaderflag : false
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	tileOnClick(){
		if((this.props.app.companyid == 1 && ['Mumbai','Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7){
			this.props.history.push("/workinprogressbygroup")
		}else if(this.props.app.companyid == 6 || (this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch))){
			this.props.history.push("/workinprogressbystate")
		}else if (this.props.app.companyid == 8) {
			this.props.history.push({pathname: `/workinprogressbyhospital/null`, params: {groupid: null,territoryid:null}});
		}else{
			this.props.history.push("/workinprogressbydistrict")
		}
	}

	render() {
		let { workinprogress,totalwipcalls,loaderflag } = this.state;
		let breakdowndays = '7 Days';
		if(this.props.app.companyid == 8) breakdowndays = '5 Days';
		return (
			<div className="row no-gutters h-100" onClick={()=>{this.tileOnClick()}}>
				<div className="col-md-12">
					<SectionLoadingcontainer isloading={loaderflag}></SectionLoadingcontainer>
					<div className="row">
						<div className="col-md-12">
							<div className="section-header-title-small" style={{float:'left',color: "#008060"}}>Work In Progress - WIP</div>
							<div className="section-count-small" style={{float:'right',color: "#405FFF"}}> {totalwipcalls}</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md-12">
							{workinprogress.length > 0 ? <table className="table dashboardwidget">
								<thead>
									<tr>
										<th></th>
										<th className="text-center table-content-small"> {`<= ${breakdowndays}`}</th>
										<th className="text-center table-content-small"> {`> ${breakdowndays}`}</th>
									</tr>
								</thead>
								<tbody>
									{workinprogress.map((item, key) => {
										return <tr key={key}>
											<td className="text-left table-content-small">{item.zzzcontractcoveragestatus}</td>
											<td className={`text-center table-body-count-small ${this.props.app.branch == 'Tripura New' ? 'trimed-text-red' : ''}`}>{item.less_7}</td>
											<td className={`text-center table-body-count-small ${this.props.app.branch == 'Tripura New' ? 'trimed-text-red' : ''}`}>{item.more_7}</td>
										</tr>
									})}
								</tbody>
							</table> : null}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

WorkInProgress = connect(
	(state, props) => {
		let formName = 'workinprogress';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState,updateComponentState }
)(reduxForm()(WorkInProgress));

export default WorkInProgress;


// WEBPACK FOOTER //
// ./public/react/components/workinprogress.js